import { FC } from 'react';

import { Icon } from '@shared/components/icons';

type Props = {
  context: string;
  buttonTitle?: string;
};
declare global {
  interface Window {
    Kakao: any;
  }
}
const KakaoCourtesyShareButton: FC<Props> = ({ context, buttonTitle }: Props) => {
  const { ShareKakao } = Icon();

  // createDefaultButton은 호출마다 리스너가 누적돼 공유창이 중복으로 뜨므로 클릭 시 직접 전송한다
  const shareToKakao = () => {
    const kakao = window.Kakao;
    if (!kakao) return;
    if (!kakao.isInitialized()) {
      kakao.init(process.env.REACT_APP_KAKAO_SHARE_JAVASCRIPT_KEY);
    }
    kakao.Share.sendDefault({
      objectType: 'text',
      text: context,
      buttonTitle: buttonTitle ?? ' ',
      link: {
        webUrl:
          process.env.REACT_APP_KAKAO_SHARE_COURTESY_LINK_URL ?? 'https://gipoom.com',
        mobileWebUrl:
          process.env.REACT_APP_KAKAO_SHARE_COURTESY_LINK_URL ?? 'https://gipoom.com',
      },
    });
  };

  return (
    <button onClick={shareToKakao}>
      <ShareKakao />
    </button>
  );
};

export default KakaoCourtesyShareButton;
